export const text = {
  otptitle: "Verify with OTP sent on your Email",
  otpdescription: "Enter OTP to verify",
  resendtxt: "Didn't receive it",
  retry: "Retry",
  retryin: "Retry in",
  button: "Continue",
  verifying: "Verifying",
  OTPcannotbeempty: "OTP cannot be empty.",
  Enteryouremailaddress: "Enter your email address",
};
